<template>
  <div class="t-calendar t-calendar_small">
    <cmp-header></cmp-header>

    <div class="t-calendar-body">
      <div class="t-calendar-body__day-week t-calendar_small__day-week">
        <span v-for="(item, index) in day_week_small" :key="'day_week_' + index">{{ item }}</span>
      </div>
    </div>

    <div class="t-month-grid">
      <div class="t-day t-day_small" v-for="(prev_day, index_prev_day) in days_before" :key="'prev_day_' + index_prev_day"></div>
      <cmp-day v-for="(day, index_day) in day_in_month" :key="'day_' + index_day" :day="day"  @selectDate="selectDate" :selectDate="select"></cmp-day>
      <div class="t-day t-day_small" v-for="(after_day, index_after_day) in days_after" :key="'after_day_' + index_after_day"></div>
    </div>
  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    import Header from './CalendarHeader.vue'
    import Day from './Day.vue'

    export default {
        props: ['select'],
        components: {
            'cmp-header': Header,
            'cmp-day': Day
        },
        computed: {
            ...mapGetters('calendar', ['day_week_small', 'days_before', 'days_after', 'day_in_month', 'open_day'])
        },
        methods: {
            selectDate(date){
                this.$emit('selectDate', date);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/vue_components/Calendar_modal/Calendar.vue